import { SyntheticEvent } from 'react';
import { Body, Title } from 'atoms/Typography/Typography';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import styles from './styles.module.css';

export const DeliveryInfo = ({
  onClick,
}: {
  onClick?: (e: Event | SyntheticEvent<Element, Event>) => void;
}) => {
  const { deliveryInfo } = useSiteConfig();

  const content = deliveryInfo?.description?.content || [];

  return (
    <div onClick={onClick}>
      {content.map((item, index) => {
        if (item.type === 'heading') {
          return (
            <Title type="md" className={styles.title} key={index}>
              {item.content?.[0]?.text}
            </Title>
          );
        }

        return (
          <Body type="md" className={styles.paragraph} key={index}>
            {item.content?.[0]?.text}
          </Body>
        );
      })}
    </div>
  );
};
